import { toast as hotToast } from "react-hot-toast";

const toId = (type, message) => {
  const normalized = typeof message === "string" ? message.trim() : String(message);
  return `${type}:${normalized}`;
};

const withId = (type, message, options = {}) => ({
  id: options.id || toId(type, message),
  ...options,
});

const toast = (message, options = {}) =>
  hotToast(message, withId("default", message, options));

toast.success = (message, options = {}) =>
  hotToast.success(message, withId("success", message, options));

toast.error = (message, options = {}) =>
  hotToast.error(message, withId("error", message, options));

toast.loading = (message, options = {}) =>
  hotToast.loading(message, withId("loading", message, options));

toast.dismiss = hotToast.dismiss;
toast.remove = hotToast.remove;
toast.promise = hotToast.promise;
toast.custom = hotToast.custom;

export default toast;

